import Vue from 'vue'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import { Integrations } from '@sentry/tracing'

const getEnvironment = () => {
  switch (window.location.host) {
    case 'stg.narasu.jp':
      return 'narasu staging'
    case 'cmap-stg.zula.jp':
      return 'C-MAP staging'
    case 'narasu.jp':
      return 'narasu production'
    case 'cmap.zula.jp':
      return 'C-MAP production'
    default:
      return 'local'
  }
}

export const initSentry = () => {
  Sentry.init({
    release: process.env.MIX_SENTRY_RELEASE,
    environment: getEnvironment(),
    dsn: process.env.MIX_SENTRY_DSN,
    integrations: [
      new VueIntegration({
        Vue,
        tracing: true,
      }),
      new Integrations.BrowserTracing(),
    ],
    tracesSampleRate: 1.0,
    autoSessionTracking: true,
  })
}

export default null
